import { ModalsKey } from '@/enums/modalsKey';
import { ModalLayout } from '@starsoft/common/components';
import CountryRedirectContent from './Content';

export default function CountryRedirectModal() {
  return (
    <ModalLayout title="" modal={ModalsKey.Redirect}>
      <CountryRedirectContent />
    </ModalLayout>
  );
}
